import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { customerService } from "../../services";
import "./Ajoy.scss";



class Ajoy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: "loading",
            showCodeModal: false,
            codeDigits: ["", "", "", ""],
            amwayNumber: null,
            partyId: null,

            selectedMonth: "",
            selectedStatus: "",
            selectedOrderNo: "",
            selectedAmount: "",
            selectedCount: "",

            monthlySummary: [],
            rawSubscriptions: [],

            selectedIndex: null,
            currentIndex: null,

            showNoDataModal: false,
        };
    }


    formatCycleCode = (cycleCode) => {
        if (!cycleCode || cycleCode.length !== 6) return cycleCode;
        const year = cycleCode.slice(0, 4);
        const month = cycleCode.slice(4, 6);
        return `${month}/${year}`;
    };

    thaiMonths = [
        "ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."
    ];




    formatActiveFromDateTH = (iso, index) => {
        if (!iso) return "";
        const now = new Date();
        if (Number(index) === 1) {
            const d = new Date(iso);
            const month = this.thaiMonths[d.getMonth()];
            const yearTH = d.getFullYear() + 543;

            const nextDate = new Date(d.getFullYear(), d.getMonth() + 1, 1);
            const nextMonth = this.thaiMonths[nextDate.getMonth()];
            const nextYearTH = nextDate.getFullYear() + 543;

            if (yearTH === nextYearTH) {
                return `${month} - ${nextMonth} ${yearTH}`;
            }
            return `${month} ${yearTH} - ${nextMonth} ${nextYearTH}`;
        }

        const d = new Date(iso);
        const month = this.thaiMonths[d.getMonth()];
        const yearTH = d.getFullYear() + 543;

        return `${month} ${yearTH}`;
    };



    formatYearTH = (iso) => {
        if (!iso) return "";
        return new Date(iso).getFullYear() + 543;
    };

    // สร้าง summary ตาม status + ยอดรวมต่อเดือนจาก msg
    buildMonthlySummary = (data) => {
        if (!Array.isArray(data)) return [];

        const summaryMap = data.reduce((acc, sub) => {
            const cycle = sub.cycle_code || "unknown";

            if (!acc[cycle]) {
                acc[cycle] = {
                    cycleCode: cycle,
                    label: this.formatCycleCode(cycle),

                    ACTIVE: 0,
                    AWAITING: 0,
                    REVOKED: 0,

                    total_ap: 0,
                    total_bv: 0,
                    total_pv: 0,
                    activate_from_date: sub.activate_from_date || null,
                    order_id: null,
                    coupons: [],
                    hasCoupon: false,
                };
            }

            const bucket = acc[cycle];

            // นับ status
            if (sub.status === "ACTIVE") {
                bucket.ACTIVE += 1;
            } else if (sub.status === "AWAITING") {
                bucket.AWAITING += 1;
            } else if (sub.status === "REVOKED") {
                bucket.REVOKED += 1;
            }

            // รวมยอด order (ถ้ามี)
            if (sub.order && sub.order.order_payload) {
                const payload = sub.order.order_payload;
                bucket.total_ap += payload.total_ap || 0;
                bucket.total_bv += payload.total_bv || 0;
                bucket.total_pv += payload.total_pv || 0;

                bucket.order_id = sub.order.order_id;
            }

            if (sub.coupons && sub.coupons.length > 0) {
                bucket.coupons = sub.coupons;
                bucket.hasCoupon = true;
            }
            return acc;
        }, {});

        return Object.values(summaryMap);
    };

    preloadNotiImage = () => {
        const img = new Image();
        img.src = "/images/ajoy/ajoy-noti.png";
    };

    componentDidMount() {
        this.preloadNotiImage();
        this.checkCustomer();
    }

    componentDidUpdate(prevProps) {
        if (this.props.profile.userId !== prevProps.profile.userId) {
            this.checkCustomer();
        }
    }

    checkCustomer() {
        const { profile } = this.props;
        if (!profile?.userId) return;
        this.setState({ status: "loading" });
        customerService
            .get(profile.userId)
            .then((res) => {
                if (res && res._id && ["abo", "member"].includes(res.type)) {
                    return axios.post(`${process.env.REACT_APP_API_URL}/customers/ajoy`, {
                        uid: profile.userId,
                        amwayNumber: res.amwayNumber,//res.amwayNumber,//'7025541983', // res.amwayNumber,
                        partyId: res.partyId,
                    });
                } else {
                    this.setState({
                        status: "notfound",
                        showNoDataModal: true,
                    });
                    return null;
                }
            })
            .then((response) => {
                if (!response || !Array.isArray(response.data) || response.data.length === 0) {
                    this.setState({
                        status: "notfound",
                        showNoDataModal: true
                    });
                    return;
                }
                if (!response) return;

                const msg = response.data; // == array ที่ส่งมา

                if (!Array.isArray(msg) || msg.length === 0) {
                    this.setState({
                        status: "notfound",
                        showNoDataModal: true,
                    });
                    return;
                }

                // เก็บดิบ ๆ ไว้ก่อน + สร้าง summary ตาม status/เดือน
                const monthlySummary = this.buildMonthlySummary(msg);


                let initialSelectedMonth = this.state.selectedMonth;
                let initialSelectedStatus = this.state.selectedStatus;
                let initialSelectedOrderNo = this.state.selectedOrderNo;
                let initialSelectedAmount = this.state.selectedAmount;
                let initialSelectedCount = this.state.selectedCount;
                let currentIndex = null;
                let selectedIndex = null;

                if (monthlySummary.length > 0) {
                    const now = new Date();
                    const currentCycle = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}`;

                    currentIndex = monthlySummary.findIndex(m => m.cycleCode === currentCycle);

                    if (currentIndex === -1) {
                        currentIndex = monthlySummary.findIndex(m => m.AWAITING > 0);
                    }

                    if (currentIndex === -1) {
                        currentIndex = monthlySummary.length - 1;
                    }

                    selectedIndex = currentIndex;

                    const currentMonth = monthlySummary[currentIndex];
                    const firstRevokedIndex = monthlySummary.findIndex(m => m.REVOKED > 0);

                    let computedStatus = "";

                    if (currentMonth.REVOKED > 0 && currentIndex == firstRevokedIndex) {
                        computedStatus = "ขาดซื้อ";
                    } else if (firstRevokedIndex !== -1 && currentIndex > firstRevokedIndex) {
                        computedStatus = "หมดสิทธิ์";
                    } else if (currentMonth.ACTIVE > 0) {
                        computedStatus = "ซื้อแล้ว";
                    } else {
                        computedStatus = "รอสั่งซื้อ";
                    }

                    initialSelectedStatus = computedStatus;

                    // ถ้าเป็นขาดซื้อ/หมดสิทธิ์ ต้องเคลียร์ order no + amount
                    if (computedStatus === "ขาดซื้อ" || computedStatus === "หมดสิทธิ์") {
                        initialSelectedOrderNo = "";
                        initialSelectedAmount = "";
                    }
                    const isPurchased = currentMonth.ACTIVE > 0;

                    initialSelectedMonth = this.formatActiveFromDateTH(currentMonth.activate_from_date, currentIndex + 1)

                    // ใช้ computedStatus ที่คำนวณไว้แล้ว — ห้ามเขียนทับ
                    initialSelectedStatus = computedStatus;

                    // ถ้าซื้อแล้ว → ให้แสดง order
                    if (computedStatus === "ซื้อแล้ว") {
                        initialSelectedOrderNo = currentMonth.order_id || "";
                        initialSelectedAmount = currentMonth.total_ap
                            ? currentMonth.total_ap.toLocaleString()
                            : "";
                    } else {
                        // ถ้าเป็น "ขาดซื้อ" หรือ "หมดสิทธิ์" หรือ "รอสั่งซื้อ" → clear order info
                        initialSelectedOrderNo = "";
                        initialSelectedAmount = "";
                    }
                    initialSelectedCount = `${currentIndex + 1}/${monthlySummary.length}`;
                }

                this.setState({
                    status: "ajoy",
                    rawSubscriptions: msg,
                    monthlySummary,

                    selectedMonth: initialSelectedMonth,
                    selectedStatus: initialSelectedStatus,
                    selectedOrderNo: initialSelectedOrderNo,
                    selectedAmount: initialSelectedAmount,
                    selectedCount: initialSelectedCount,
                    currentIndex,
                    selectedIndex,
                });


                this.setState({
                    status: "ajoy",
                    rawSubscriptions: msg,
                    monthlySummary,

                    // 👇 set ค่าเริ่มต้นให้ bottom card
                    selectedMonth: initialSelectedMonth,
                    selectedStatus: initialSelectedStatus,
                    selectedOrderNo: initialSelectedOrderNo,
                    selectedAmount: initialSelectedAmount,
                    selectedCount: initialSelectedCount,
                    currentIndex,
                    selectedIndex,
                });

            })
            .catch(() => {
                this.setState({
                    status: "notfound",
                    showNoDataModal: true,
                });
            });
    }

    renderTerms() {
        return (
            <div className="ajoy fullscreen">
                <div className="ajoy-terms-wrapper">
                    <div className="ajoy-terms-card">
                        <div className="ajoy-terms-pill">
                            เงื่อนไขการร่วมกิจกรรม A JOY
                        </div>

                        <div className="ajoy-terms-content">
                            <div className="ajoy-terms-title">
                                เงื่อนไขการร่วมกิจกรรม A JOY
                            </div>
                            <ol className="ajoy-terms-list">
                                <li>
                                    การยอมรับข้อกำหนด<br />
                                    เมื่อคุณใช้บริการนี้ ถือว่าคุณยอมรับและตกลงปฏิบัติตามข้อกำหนด
                                    และเงื่อนไขเหล่านี้
                                </li>
                                <li>
                                    การใช้งานบริการ<br />
                                    คุณตกลงที่จะใช้บริการเพื่อวัตถุประสงค์ที่ถูกต้องตามกฎหมาย
                                    และจะไม่กระทำการใด ๆ ที่อาจก่อให้เกิดความเสียหาย
                                    รบกวน หรือรบเร้าแก่การทำงานของบริการ
                                </li>
                                <li>
                                    ความรับผิดชอบของบัญชีผู้ใช้<br />
                                    หากคุณลงทะเบียนบัญชี คุณมีหน้าที่รับผิดชอบในการเก็บรักษาข้อมูลเข้าสู่ระบบของคุณไว้เป็นความลับ
                                    และรับผิดชอบต่อการกระทำใด ๆ ที่เกิดขึ้นผ่านบัญชีของคุณ
                                </li>
                                <li>
                                    ทรัพย์สินทางปัญญา<br />
                                    เนื้อหา เครื่องหมายการค้า และสื่อทั้งหมดที่ให้บริการนี้เป็นทรัพย์สินของบริษัทหรือผู้ให้อนุญาต คุณไม่สามารถทำซ้ำหรือเผยแพร่โดยไม่ได้รับอนุญาต
                                </li>

                                <li>
                                    การจำกัดความรับผิดชอบ<br />
                                    บริษัทจะไม่รับผิดชอบต่อความเสียหายใด ๆ ไม่ว่าจะโดยตรง โดยอ้อม หรือโดยบังเอิญ ที่เกิดจากการใช้งานบริการของคุณ
                                </li>


                                <li>
                                    การระงับหรือยกเลิกการให้บริการ<br />
                                    เราขอสงวนสิทธิ์ในการระงับหรือยกเลิกการเข้าถึงบริการได้ทุกเมื่อ โดยไม่ต้องแจ้งล่วงหน้า หากมีการละเมิดข้อกำหนดและเงื่อนไขเหล่านี้
                                </li>

                                <li>
                                    การเปลี่ยนแปลงเงื่อนไข<br />
                                    บริษัทขอสงวนสิทธิ์ในการแก้ไขหรือเปลี่ยนแปลงเงื่อนไขได้ตามความเหมาะสม
                                    โดยจะแจ้งให้ทราบล่วงหน้าเมื่อมีการปรับปรุง
                                </li>
                            </ol>
                        </div>
                    </div>

                    <button
                        className="ajoy-terms-close-btn"
                        onClick={this.closeTermsModal}
                    >
                        ปิด
                    </button>
                </div>
            </div>
        );
    }

    renderNoDataModal() {
        return (
            <div className="ajoy-modal-overlay">
                <div className="ajoy-modal-card">
                    <div className="ajoy-modal-logo">
                        <img
                            src="/images/ajoy/ajoy-noti.png"
                            alt="A Joy"
                            className="ajoy-noti-logo"
                        />
                    </div>

                    <div className="ajoy-modal-title">ขออภัย</div>
                    <div className="ajoy-modal-title">คุณไม่ได้รับสิทธิ์การเข้าร่วมกิจกรรม A JOY</div>
                    <div className="ajoy-modal-text">
                        สั่งซื้อต่อเนื่อง รับคูปองเงินสด{" "}
                        <span
                            className="ajoy-modal-link"
                            onClick={() => {
                                if (window.liff) {
                                    window.liff.openWindow({
                                        url: `${process.env.REACT_APP_AJOY_TC}`,
                                        external: false,   // เปิดใน LINE
                                    });
                                } else {
                                    window.open(
                                        `${process.env.REACT_APP_AJOY_TC}`,
                                        "_blank"
                                    );
                                }
                            }}
                        >
                            อ่านรายละเอียดคลิก
                        </span>
                    </div>

                    <button
                        className="ajoy-modal-btn"
                        onClick={this.handleClose}
                    >
                        ปิด
                    </button>
                </div>
            </div>
        );
    }





    handleConfirm = () => {
        this.setState({ showCodeModal: true }, () => {
            if (this.digit0) this.digit0.focus();
        });
    };

    handleCancelCode = () => {
        this.setState({ showCodeModal: false, codeDigits: ["", "", "", ""] });
        if (window.liff && typeof window.liff.closeWindow === "function") {
            window.liff.closeWindow();
        } else {
            window.close();
        }
    };

    handleShowValue = (month, status, orderNo, amount, count, index) => {
        this.setState({
            selectedMonth: month,
            selectedStatus: status,
            selectedOrderNo: orderNo,
            selectedAmount: amount,
            selectedCount: count,
            selectedIndex: index,
        });
    };


    handleClose = () => {
        if (window.liff && typeof window.liff.closeWindow === "function") {
            window.liff.closeWindow();
        } else {
            window.close();
        }
    };

    closeTermsModal = () => {
        this.setState({ status: "ajoy" });
    };

    renderHeader() {
        return (
            <div className="headerBar">
                <div
                    className="headerBar-link"
                    onClick={() => {
                        if (window.liff) {
                            window.liff.openWindow({
                                url: `https://liff.line.me/${process.env.REACT_APP_LIFF_CLIENT_ID_COUPON}`,
                                external: false,   // เปิดใน LINE
                            });
                        } else {
                            window.open(
                                `https://liff.line.me/${process.env.REACT_APP_LIFF_CLIENT_ID_COUPON}`,
                                "_blank"
                            );
                        }
                    }}
                />
            </div>
        );
    }


    renderAJoy() {
        const { monthlySummary, currentIndex, selectedIndex } = this.state;
        const firstAwaitingIndex = this.state.monthlySummary.findIndex(m => m.AWAITING > 0);
        const firstRevokedIndex = monthlySummary.findIndex(m => m.REVOKED > 0);

        return (
            <div className="ajoy fullscreen">
                {this.renderHeader()}
                {/* {this.state.showNoDataModal && this.renderNoDataModal()} */}
                <div className="containerNotFound">
                    <div className="ajoy-card">
                        <div className="ajoy-card-header">
                            <div className="title">ตารางสะสมยอด</div>
                            <div
                                className="condition-link"
                                onClick={() => {
                                    if (window.liff) {
                                        window.liff.openWindow({
                                            url: `${process.env.REACT_APP_AJOY_TC}`,
                                            external: false,   // เปิดใน LINE
                                        });
                                    } else {
                                        window.open(
                                            `${process.env.REACT_APP_AJOY_TC}`,
                                            "_blank"
                                        );
                                    }
                                }}
                            >
                                เงื่อนไขการร่วมกิจกรรม
                            </div>

                        </div>

                        <div className="ajoy-month-grid">
                            {this.state.monthlySummary &&
                                this.state.monthlySummary.map((m, index) => {

                                    const isPurchased = m.ACTIVE > 0;
                                    const isAwaiting = m.AWAITING > 0;
                                    const isRevoked = m.REVOKED > 0;
                                    const isCurrent = index === currentIndex;
                                    const isExpired = firstRevokedIndex !== -1 && index > firstRevokedIndex;
                                    const monthLabel = `ครั้งที่ ${index + 1}`;
                                    const showBadge = ((index + 1) % 3 === 0);


                                    // 🟣 กรณีหลังจากเจอ REVOKED แล้ว → หมดสิทธิ์ทั้งหมด
                                    if (isExpired) {
                                        return (
                                            <div
                                                key={m.cycleCode}
                                                className={`month-pill reward  ${this.state.selectedIndex === index ? "bold" : ""}`}
                                                onClick={() =>
                                                    this.handleShowValue(
                                                        this.formatActiveFromDateTH(m.activate_from_date, index + 1),
                                                        "หมดสิทธิ์",
                                                        "",
                                                        "",
                                                        `${index + 1}/${monthlySummary.length}`,
                                                        index
                                                    )
                                                }
                                            >
                                                หมดสิทธิ์
                                                {showBadge && <span className="badge-gray"></span>}

                                            </div>
                                        );
                                    }

                                    // 🔴 เดือนที่เป็น REVOKED (ตัวแรก)
                                    if (isRevoked) {
                                        return (
                                            <div
                                                key={m.cycleCode}
                                                className={`month-pill redorder ${this.state.selectedIndex === index ? "bold" : ""}`}
                                                onClick={() =>
                                                    this.handleShowValue(
                                                        this.formatActiveFromDateTH(m.activate_from_date, index + 1),
                                                        "ขาดซื้อ",
                                                        "",
                                                        "",
                                                        `${index + 1}/${monthlySummary.length}`,
                                                        index
                                                    )
                                                }
                                            >
                                                ขาดซื้อ
                                            </div>
                                        );
                                    }

                                    // ✅ ACTIVE = ซื้อแล้ว
                                    if (isPurchased) {
                                        return (
                                            <div
                                                key={m.cycleCode}
                                                className={`month-pill success  ${this.state.selectedIndex === index ? "bold" : ""}`}
                                                onClick={() =>
                                                    this.handleShowValue(
                                                        this.formatActiveFromDateTH(m.activate_from_date, index + 1),
                                                        "ซื้อแล้ว",
                                                        m.order_id || "",
                                                        m.total_ap ? m.total_ap.toLocaleString() : "",
                                                        `${index + 1}/${monthlySummary.length}`,
                                                        index
                                                    )
                                                }
                                            >


                                                {showBadge && !m.hasCoupon ? (
                                                    <>
                                                        {showBadge && <span className="badge-text" style={{ fontWeight: isCurrent ? "bold" : "normal" }}>รอรับ</span>}
                                                        {showBadge && <span className="badge"></span>}
                                                    </>
                                                ) : (
                                                    <>
                                                        <span className="check-icon"></span>
                                                        {showBadge && <span className="badge-text" style={{ fontWeight: isCurrent ? "bold" : "normal" }}>รับแล้ว</span>}
                                                    </>
                                                )}
                                            </div>
                                        );
                                    }

                                    // ⚪ default = AWAITING / รอสั่งซื้อ
                                    return (
                                        <div
                                            key={m.cycleCode}
                                            className={`month-pill ${isCurrent ? "current" : ""} ${selectedIndex === index ? "selected" : ""}`}
                                            onClick={() =>
                                                this.handleShowValue(
                                                    this.formatActiveFromDateTH(m.activate_from_date, index + 1),
                                                    "รอสั่งซื้อ",
                                                    "",
                                                    "",
                                                    `${index + 1}/${monthlySummary.length}`,
                                                    index
                                                )
                                            }
                                        >
                                            {monthLabel}
                                            {showBadge && <span className="badge"></span>}
                                        </div>
                                    );
                                })}
                        </div>




                    </div >

                    <div className="ajoy-bottom-card">
                        <div className="order-info">
                            <div className="order-left">
                                <span className={
                                    this.state.selectedStatus === "ขาดซื้อ"
                                        ? "order-icon-red"
                                        : this.state.selectedStatus === "หมดสิทธิ์"
                                            ? "order-icon-gray"
                                            : this.state.selectedOrderNo === ""
                                                ? "order-icon-gray"
                                                : "order-icon-green"
                                }
                                ></span>

                                <span className="order-month">{this.state.selectedMonth}</span>
                                <span className={
                                    this.state.selectedStatus === "ขาดซื้อ"
                                        ? "order-status-red"
                                        : this.state.selectedStatus === "หมดสิทธิ์"
                                            ? "order-status-gray"
                                            : this.state.selectedOrderNo === ""
                                                ? "order-status-gray"
                                                : "order-status-green"
                                }
                                >
                                    {this.state.selectedStatus}
                                </span>
                            </div>
                            <div className="order-count">{this.state.selectedCount}</div>
                        </div>

                        {this.state.selectedOrderNo && (
                            <div className="order-info detailorder">
                                <div className="order-left">
                                    <span className="order-month-detail">เลขที่คำสั่งซื้อ</span>
                                </div>
                                <div className="order-count-detail">
                                    {this.state.selectedOrderNo}
                                </div>
                            </div>
                        )}

                        {this.state.selectedAmount && (
                            <div className="order-info detailorder">
                                <div className="order-left">
                                    <span className="order-month-detail">ยอดสั่งซื้อ</span>
                                </div>
                                <div className="order-count-detail">
                                    {this.state.selectedAmount}
                                </div>
                            </div>
                        )}

                        {(!this.state.selectedOrderNo && this.state.selectedStatus !== "ขาดซื้อ" && this.state.selectedStatus !== "หมดสิทธิ์" && this.state.selectedIndex === this.state.currentIndex) && (
                            <button className="order-button" onClick={() => window.location.href = "line-ordering?isInstallment=FALSE"}>สั่งซื้อเลย</button>
                        )}

                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { status, showNoDataModal } = this.state;

        return (
            <>
                <style></style>

                {status === "loading" && (
                    <div className="ajoy fullscreen loading-center">
                        <img
                            src="/images/ajoy/ajoy-load-new.gif"
                            alt="loading"
                            className="ajoy-loading-gif"
                        />
                    </div>
                )}

                {status === "ajoy" && this.renderAJoy()}

                {status === "notfound" && showNoDataModal && (
                    <div className="ajoy fullscreen">
                        {this.renderNoDataModal()}
                    </div>
                )}

                {status === "terms" && this.renderTerms()}
            </>
        );
    }



}

const mapStateToProps = (state) => ({
    profile: state.profile,
});

export default connect(mapStateToProps)(Ajoy);